import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
export const useIsScrolled = () => {
  const $ = _c(4);
  const scrolled_element_ref = useRef(null);
  const [has_scrolled, setHasScrolled] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const content_element = scrolled_element_ref.current;
      if (!content_element) {
        return;
      }
      const handleScroll = () => {
        const scroll_left = content_element.scrollLeft;
        setHasScrolled(scroll_left > 0);
      };
      handleScroll();
      content_element.addEventListener("scroll", handleScroll);
      return () => {
        content_element.removeEventListener("scroll", handleScroll);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== has_scrolled) {
    t2 = {
      has_scrolled,
      scrolled_element_ref
    };
    $[2] = has_scrolled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};